import { Component, OnInit,  Input } from '@angular/core';

@Component({
    selector: 'top-holding-fund',
    templateUrl: './top-holding-fund.html',
    styleUrl: '../tab-detail-fund.scss'
})

export class TopHoldingFund implements OnInit {
    @Input('topHolding') topHolding: any;
    @Input('updateTime') updateTime: any;
    @Input('bondList') bondList: any;

    constructor() {
    }

    ngOnInit() {
    }
}
